// Generated by scripts/translate-catalog.mjs from scripts/translate-catalog.config.json.
// Do not edit: add a language to the config and re-run the script.
import 'dayjs/locale/de';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';
import 'dayjs/locale/ro';
import 'dayjs/locale/pl';
import 'dayjs/locale/nl';
import 'dayjs/locale/da';
import antd_de from 'antd/locale/de_DE';
import antd_en from 'antd/locale/en_GB';
import antd_fr from 'antd/locale/fr_FR';
import antd_es from 'antd/locale/es_ES';
import antd_it from 'antd/locale/it_IT';
import antd_pt from 'antd/locale/pt_PT';
import antd_ro from 'antd/locale/ro_RO';
import antd_pl from 'antd/locale/pl_PL';
import antd_nl from 'antd/locale/nl_NL';
import antd_da from 'antd/locale/da_DK';

export const LANGUAGE_CODES = ['de', 'en', 'fr', 'es', 'it', 'pt', 'ro', 'pl', 'nl', 'da'];
export const LANGUAGE_NAMES = {
  de: 'Deutsch',
  en: 'English',
  fr: 'Français',
  es: 'Español',
  it: 'Italiano',
  pt: 'Português',
  ro: 'Română',
  pl: 'Polski',
  nl: 'Nederlands',
  da: 'Dansk',
};
export const DAYJS_LOCALES = {
  de: 'de',
  en: 'en-gb',
  fr: 'fr',
  es: 'es',
  it: 'it',
  pt: 'pt',
  ro: 'ro',
  pl: 'pl',
  nl: 'nl',
  da: 'da',
};
export const ANTD_LOCALES = {
  de: antd_de,
  en: antd_en,
  fr: antd_fr,
  es: antd_es,
  it: antd_it,
  pt: antd_pt,
  ro: antd_ro,
  pl: antd_pl,
  nl: antd_nl,
  da: antd_da,
};
